import axios from 'axios'

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {'Content-Type': 'application/json;charset=utf-8'},
    timeout: 10000, //withCredentials: true,
});
http.interceptors.request.use(req => {
    const token = localStorage.getItem('autoken');
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
});

export default http
